import { Card, Grid, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import parse from "html-react-parser";
import { useState } from "react";
import LabelsContext from "../../../lang/LabelsContext";
import HtmlTooltip from "../../system/html-tooltip/HtmlTooltip";
import TabReview from "../article-details/tab-review/TabReview";
import {
  classificationOfManuscript,
  correction,
  summaryOfArticle,
  titleOfManuscript,
} from "../manuscript/submit/TooltipText";
import TabUploadRevision from "./tab-upload-revision/TabUploadRevision";
import UploadRevisionService, { UploadRevisionServiceType } from "./UploadRevisionService";
import useStyles from "./UploadRevisionStyle";

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function UploadRevision() {
  const classes = useStyles();
  const theme = useTheme();
  const { Labels } = LabelsContext();
  const [value, setValue] = useState(0);
  const { article }: UploadRevisionServiceType = UploadRevisionService();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const InfoIcon = (props: any) => (
    <HtmlTooltip title={props.title}>
      <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
    </HtmlTooltip>
  );

  return (
    <div className={classes.root}>
      <Typography component="span" variant="h5">
        {Labels.UPLOAD_REVISION}
      </Typography>
      <AppBar position="static" color="default" className={classes.appBar}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label={Labels.INSTRUCTIONS} {...a11yProps(0)} />
          <Tab label={Labels.REVIEWS} {...a11yProps(1)} />
          <Tab label={Labels.MANUSCRIPT_INFORMATION} {...a11yProps(2)} />
          <Tab label={Labels.REVISION_UPLOAD} {...a11yProps(3)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} dir={theme.direction}>
        <Typography component="span" variant="h5">
          Instructions
        </Typography>
        <br />
        Dear Author,
        <br />
        Your article has been reviewed by reviewers from Rhinology. They have concluded that you article is not yet
        suitable for Rhinology journal. Using the buttons on the top you can navigate to the comments of the reviewers.
        Review these comments and make the indicated changes in your manusript after which you can submit a revision of
        your article.
        <br />
        <br />
        <b>Todo:</b>
        <br />
        <ul>
          <li>Upload your revised manuscript</li>
          <li>Upload a marked version of your manuscript</li>
          <li> Upload a letter of rebuttal clearly responding to the reviewer comments.</li>
        </ul>
      </TabPanel>
      <TabPanel value={value} index={1} dir={theme.direction}>
        <TabReview editorView={false} articleId={article?.id} />
      </TabPanel>
      <TabPanel value={value} index={2} dir={theme.direction}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={2}>
            <Typography component="span" variant="body1">
              {Labels.TITLE}
            </Typography>
          </Grid>
          <Grid item>
            <InfoIcon title={titleOfManuscript} />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography component="span" variant="body1">
              {article.articleTitle}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography component="span" variant="body1">
              {Labels.MANUSCRIPT_CLASSIFICATION}
            </Typography>
          </Grid>
          <Grid item>
            <InfoIcon title={classificationOfManuscript} />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography component="span" variant="body1">
              {article?.type?.name}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography component="span" variant="body1">
              Comments to the editor
            </Typography>
          </Grid>
          <Grid item>
            <InfoIcon title={correction} />
          </Grid>
          <Grid className={classes.widthFull} item xs={12} sm={9}>
            <Card className={classes.padding}>
              <div>{parse(article.coverLetter ?? "")}</div>
            </Card>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography component="span" variant="body1">
              {Labels.ABSTRACT}
            </Typography>
          </Grid>
          <Grid item>
            <InfoIcon title={summaryOfArticle} />
          </Grid>
          <Grid className={classes.widthFull} item xs={12} sm={9}>
            <Card className={classes.padding}>
              <div>{parse(article.abstractText ?? "")}</div>
            </Card>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={value} index={3} dir={theme.direction}>
        <TabUploadRevision article={article} />
      </TabPanel>
    </div>
  );
}
